import React from 'react';

import { CartProvider } from '@/context/CartContext';

export const Root = (element: HTMLElement): JSX.Element => {
  return (
    <CartProvider>
      {/* <Fonts /> */}
      <>{element.children}</>
    </CartProvider>
  );
};
